"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 270px)',
};
const gridHeightHistory = {
    height: '38vh',
};
const modalContainer = (theme) => ({
    width: 'min-content',
    padding: '24px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerMutation = (theme) => ({
    width: 'fit-content',
    minWidth: 800,
    padding: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalContainerDetails = (theme) => ({
    width: 'fit-content',
    minWidth: 800,
    padding: '20px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = {
    padding: 10,
    paddingTop: 0,
    width: 432,
    height: 376,
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    padding: 0,
    marginBottom: 16
};
const itemAdd = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
const inputWrapper = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 12,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
const inputItem = {
    height: 27,
    borderRadius: 5,
};
const buttonSave = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10,
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
};
const dropdownStyle = (theme) => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const stockpileSubComponentContainer = {
    display: 'flex',
    gridTemplateColumns: '69% auto',
    gridGap: '10px',
    minHeight: '82vh',
};
const button = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '130px',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: constants_1.color.buttonDark,
});
const buttonPassive = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'right',
    justifyContent: 'center',
    width: '130px',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: color,
    marginLeft: 20,
});
const buttonModify = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'right',
    justifyContent: 'center',
    width: '130px',
    borderRadius: 8,
    padding: '12px',
    backgroundColor: color,
});
const buttonFont = {
    fontSize: '20px',
    fontWeight: '600',
    margin: 0,
    marginLeft: 8,
};
const buttonFontPassive = {
    fontSize: '15px',
    fontWeight: '600',
    margin: 0,
    marginLeft: 8,
};
const stockpileSubComponentContainerRightBody = theme => ({
    backgroundColor: theme === 'light' ? '#F5F6F7' : constants_1.color.backgroundDark,
    margin: '30px 0px 10px 0px',
    padding: '15px 20px',
    borderRadius: '10px',
    height: '70%'
});
const stockpileSubComponentContainerRightText = {
    display: 'grid',
    gridTemplateColumns: '40% auto',
    marginBottom: '3vh',
    marginLeft: '10px',
    fontSize: '1.5vh'
};
const stockpileSubComponentContainerRight = theme => ({
    width: '40vw',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    borderRadius: '10px',
    padding: '20px 20px 0px 20px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    marginBottom: 20,
    height: '76vh'
    // minWidth: 500,
    // maxHeight: '770px'
});
const stockpileSubComponentContainerRightHidder = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    fontWeight: 'bold',
};
const stockpileSubComponentContainerRightHidderStatus = {
    display: 'flex',
    alignItems: 'center',
    direction: 'rtl',
};
const stockpileSubComponentContainerRightHidderButton = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'space-between'
};
const stockpileSubComponentContainerLeft = theme => ({
    width: '100%',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    borderRadius: '10px',
    overflow: 'hidden',
    height: '20vh',
});
const stockpileSubComponentContainerLeftBottom = theme => ({
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    borderRadius: '10px',
    padding: '20px',
    display: 'grid',
    gridGap: '10px',
    gridTemplateRows: '15% auto',
});
const stockpileSubComponentContainerLeftBottomLed = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10
};
const stockpileSubComponentContainerBottom = theme => ({
    margin: '10px 5px 20px 5px',
    zIndex: 5,
    // width: '60%',
    height: 200,
    borderRadius: '10px',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const stockpileSubComponentContainerHistory = theme => ({
    margin: '20px 5px 20px 5px',
    zIndex: 5,
    height: '44vh',
    borderRadius: '10px',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const stockpileSubComponentContainerHistoryView = theme => ({
    margin: '0px 5px 20px 5px',
    zIndex: 5,
    height: '76vh',
    borderRadius: '10px',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const stockpileSubComponentContainerBottomPenalty = theme => ({
    margin: '0px 5px 20px 5px',
    zIndex: 5,
    borderRadius: '10px',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    height: '30vh',
});
const stockpileSubComponentContainerLeftBottomLedHidder = {
    marginRight: '5px',
    fontSize: '20px',
    fontWeight: '600',
};
const stockpileSubComponentContainerLeftBottomLedText = {
    display: 'flex',
    flexDirection: 'column',
    height: '12vh',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
    fontSize: 'xx-large',
    borderRadius: '10px',
};
const stockpileSubComponentContainerRightBottomLedText = {
    display: 'grid',
    alignContent: 'flex-start',
    justifyItems: 'center',
    backgroundColor: 'white',
    marginBottom: '10px',
    borderRadius: '10px',
};
const buttonPenalty = (color) => ({
    display: 'flex',
    alignItems: 'center',
    width: '30%',
    height: 50,
    borderRadius: 8,
    padding: '8px 8px',
    backgroundColor: color,
    margin: '0px 0px 15px 0px',
    justifyContent: 'center',
});
const buttonNoPenalty = (color) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: 8,
    padding: '8px 8px',
    backgroundColor: color,
    margin: '0px 0px 5px 0px',
    justifyContent: 'center',
});
const btnPenaltyContainer = (theme) => ({
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const modalContainerPenalty = (theme) => ({
    // minWidth: 1076,
    textAlign: 'center',
    width: '50vw',
    padding: '20px',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const btnModifyPassive = {
    display: 'flex',
    alignItems: 'center'
};
const passiveGridButton = {
    display: 'grid',
    gridTemplateAreas: 'p1 p2 p3'
};
const canvasWrapper = (theme) => ({
    width: 788,
    padding: 16,
    borderRadius: 8,
    marginBottom: 24,
    textAlign: 'center',
    backgroundColor: theme === 'dark' ? constants_1.color.sidebarItemActiveDark : constants_1.color.semiWhite,
});
exports.default = {
    button,
    itemAdd,
    inputItem,
    buttonFont,
    gridHeight,
    modalTitle,
    buttonSave,
    modalHeader,
    buttonTitle,
    buttonDelete,
    inputWrapper,
    buttonModify,
    canvasWrapper,
    dropdownStyle,
    buttonPassive,
    buttonPenalty,
    modalContainer,
    buttonNoPenalty,
    btnModifyPassive,
    buttonFontPassive,
    gridHeightHistory,
    passiveGridButton,
    btnPenaltyContainer,
    modalContainerDetails,
    modalConfirmContainer,
    modalContainerPenalty,
    modalContainerMutation,
    stockpileSubComponentContainer,
    stockpileSubComponentContainerLeft,
    stockpileSubComponentContainerRight,
    stockpileSubComponentContainerBottom,
    stockpileSubComponentContainerHistory,
    stockpileSubComponentContainerRightBody,
    stockpileSubComponentContainerRightText,
    stockpileSubComponentContainerLeftBottom,
    stockpileSubComponentContainerRightHidder,
    stockpileSubComponentContainerHistoryView,
    stockpileSubComponentContainerLeftBottomLed,
    stockpileSubComponentContainerBottomPenalty,
    stockpileSubComponentContainerLeftBottomLedText,
    stockpileSubComponentContainerRightHidderStatus,
    stockpileSubComponentContainerRightHidderButton,
    stockpileSubComponentContainerLeftBottomLedHidder,
    stockpileSubComponentContainerRightBottomLedText,
};
